import api from './api';

const addressService = {
  getAll: () => api.get('/addresses'),
  getDefault: () => api.get('/addresses/default'),
  create: (data) => api.post('/addresses', data),
  update: (id, data) => api.put(`/addresses/${id}`, data),
  setDefault: (id) => api.put(`/addresses/${id}/default`),
  remove: (id) => api.delete(`/addresses/${id}`),
};

export default addressService;
